import { Paper, PaperProps } from "@material-ui/core";
import { ReactChild, ReactFragment, ReactPortal } from "react";
import useStyles from "./component-styles";

export default function Card(props: { children: ReactChild | ReactFragment | ReactPortal | boolean | null | undefined } & PaperProps) {
	const { paper } = useStyles({});
	const { children, ...otherProps } = props;

	return (
		<Paper classes={{ root: !otherProps.classes ? paper : "" }} {...otherProps}>
			{children}
		</Paper>
	);
}
